import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Sort } from "@syncfusion/ej2-react-grids";
import { formatarData } from "../utils/functions";

const StaffList = ({ staff, onSelect }) => {
    return (
        <GridComponent
            dataSource={staff}
            allowPaging={true}
            pageSettings={{ pageSize: 15 }}
            allowSorting={true}
            rowSelected={(args) => onSelect(args.data)}
            className="cursor-pointer"
        >
            <ColumnsDirective>
                <ColumnDirective field="name" headerText="Nome" width="180" />
                <ColumnDirective field="email" headerText="Email" width="220" />
                <ColumnDirective field="admin" headerText="Admin" width="90" textAlign="Center"
                    valueAccessor={(f, d) => (d?.roles?.includes("admin") ? "✔" : null)} />
                <ColumnDirective field="master" headerText="Master" width="90" textAlign="Center"
                    valueAccessor={(f, d) => (d?.roles?.includes("master") ? "✔" : null)} />
                <ColumnDirective field="verified" headerText="Verificado" width="100" textAlign="Center"
                    valueAccessor={(f, d) => (d?.verified ? "✔" : null)} />
                <ColumnDirective field="groups" headerText="Grupos" width="200"
                    valueAccessor={(f, d) => (d?.groups || []).map((g) => g.name).join(", ")} />
                <ColumnDirective field="createdAt" headerText="Desde" width="110"
                    valueAccessor={(f, d) => formatarData(d?.createdAt)} />
            </ColumnsDirective>
            <Inject services={[Page, Sort]} />
        </GridComponent>
    );
};

export default StaffList;
